const createImageFromVideo = (
    videoElement: HTMLVideoElement,
): Promise<Blob> => {
    const canvas = document.createElement("canvas");
    const { videoWidth, videoHeight } = videoElement;

    canvas.width = videoWidth;
    canvas.height = videoHeight;
    canvas
        .getContext("2d")
        ?.drawImage(videoElement, 0, 0, videoWidth, videoHeight);
    const result = new Promise<Blob>((resolve) => {
        canvas.toBlob((blob) => {
            canvas.remove();
            if (blob) {
                resolve(blob);
            }
        });
    });
    return result;
};

export default createImageFromVideo;
